import './PrivacyPolicy.scss'

function PrivacyPolicy()
{
    return (
        <div className='container'>
            <div className='row'>
                <h1>Privacy Policy</h1>
            </div>
            <br/>
            <div className='row'>
                <h3>1. Introduction</h3>
                <p>
                    Welcome to Wrypai. This Privacy Policy explains how Wrypai (“we,” “us,” or “our”) 
                    collects, uses, discloses, and safeguards your information when you use our Android application (the “App”). 
                    Please read this Privacy Policy carefully. If you do not agree with the terms of this privacy policy, please do not access the application. We reserve the right to make changes to this Privacy Policy at any time and for any reason. 
                    We will alert you about any changes by updating the “Last Updated” date of this Privacy Policy. 
                </p>
            </div>
            <div className='row'>
                <h3>2. Information We Collect</h3>
                <p>
                    We may collect information about you in a variety of ways. The information we may collect via the App includes:
                    a. Personal Data You Provide to Us We collect information you directly provide to us when you create an account, use the App, or communicate with us. This includes:
                        Email Address: We collect your email address when you register for an account with Wrypai. This is used for account creation, verification, and communication.
                        User Content (Photos): We collect the photos you choose to upload to the App (“User Content”). By uploading photos, you grant us the right to store and process them as necessary to provide the App’s services.

                    b. Information Collected Automatically When you use our App, we may automatically collect certain information, including:
                        Usage Data: Information about how you interact with our App, such as the features you use, the actions you take, and the time, frequency, and duration of your activities.
                        Log and Device Data: Information that is automatically sent by your mobile device, which may include your device’s IP address, device model, operating system version, and crash data.
                </p>
            </div>
            <div className='row'>
                <h3>3. How We Use Your Information</h3>
                <p>
                    Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the App to:
                    <ul>
                        <li>
                            Create and manage your account.
                        </li>
                        <li>
                            Provide, operate, and maintain the core functionality of the App.
                        </li>
                        <li>
                            Process and manage the photos you upload.
                        </li>
                        <li>
                            Communicate with you. We may use your email address to respond to your comments and questions, provide customer support, and send you technical notices, updates, and security alerts.
                        </li>
                        <li>
                            <strong>For Security Purposes:</strong> To monitor and analyze usage and trends to improve the security of our App, protect against fraudulent or unauthorized activity, and enforce our Terms of Service.
                        </li>
                        <li>
                            <strong>For Operational Purposes:</strong> To diagnose and fix technology problems, improve and personalize the user experience, and for internal data analysis and research to develop and improve our services.
                        </li>
                        <li>
                            Comply with legal obligations and respond to lawful requests from public authorities.
                        </li>
                    </ul>
                </p>
            </div>
            <div className='row'>
                <h3>4. How We Share Your Information</h3>
                <p>
                    We do not sell your personal information. We may share information we have collected about you in certain situations:
                    <ul>
                        <li>
                            <strong>With Third-Party Service Providers:</strong> We may share your information with third-party vendors, consultants, and other service providers who perform services for us or on our behalf, such as cloud hosting (for storing your photos and data), data analytics, and email delivery. These providers are contractually obligated to safeguard your data.
                        </li>
                        <li>
                            <strong>By Law or to Protect Rights:</strong> If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.
                        </li>
                        <li>
                            <strong>Business Transfers:</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
                        </li>
                    </ul>
                </p>
            </div>
            <div className='row'>
                <h3>5. Data Storage and Security</h3>
                <p>
                    We use administrative, technical, and physical security measures to help protect your personal information. All information you provide, including your email and uploaded photos, is saved on secure servers.
                </p>
                <p>
                    While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse. Any information disclosed online is vulnerable to interception and misuse by unauthorized parties. Therefore, we cannot guarantee complete security if you provide personal information.
                </p>
            </div>
            <div className='row'>
                <h3>6. Your Rights and Choices</h3>
                <p>
                    You have certain rights regarding the personal information we hold about you.
                </p>
                <p>
                    <strong>Opt-Out of Communications:</strong> You may opt-out of receiving non-essential emails from us by following the unsubscribe link in those emails or by contacting us.
                </p>
                <p>
                    <strong>Access and Update:</strong> You may review and change your email address at any time through your account settings.
                </p>
                <p>
                    <strong>Data Deletion:</strong> You may delete your uploaded photos through the App’s interface. You can also request the deletion of your entire account and associated personal data by contacting us at the email address below.
                </p>
            </div>
            <div className='row'>
                <h3>7. Children’s Privacy</h3>
                <p>
                    We do not knowingly collect personal information from children under 13. If we become aware that a child under 13 has provided us with personal information, we will take steps to delete such information.
                </p>
            </div>
            <div className='row'>
                <h3>8. Contact Us</h3>
                <p>
                    If you have questions or comments about this Privacy Policy, please contact us at:
                </p>
                <p>
                    <strong>Wrypai Support Email:</strong> policy@wrypai.com
                </p>
            </div>
            <hr/>
        </div>
    );
}

export default PrivacyPolicy;